<planone-swiper
  [enableZoom]="false"
  [showSlideCount]="false"
  [showSlideNav]="false"
  [showSlideControl]="true"
  [forceAspectRatio]="false"
  [swiperOptions]="{
    slidesPerView: cardSliderConfig?.slidesPerView,
    spaceBetween: 15,
    scrollbar: cardSliderConfig?.scrollbar
  }"
  [moveToBack]="!!imageZoomed"
  desktopVariant="default"
  mobileVariant="cards"
  class="swiper__slider">
  <ng-container *ngFor="let post of posts; let i = index; trackBy: identifyPost">
    <ng-template #slide *ngIf="i < 16">
      <bau365-post-card
        [item]="post"
        [fairId]="post.fair_id"
        [exhibitor]="exhibitor"
        [pageContext]="context"
        [size]="size ?? undefined">
      </bau365-post-card>
    </ng-template>
  </ng-container>
  <ng-template #slide *ngIf="(posts ?? []).length > 16">
    <planone-more-card [moreRouterLink]="moreRouterLink" [moreQueryParams]="moreQueryParams"></planone-more-card>
  </ng-template>
</planone-swiper>
